<template>
  <wsp-modal>
    <v-card class="pb-5"
              flat>
      <v-form ref="form"
        v-model="valid"
        v-on:submit.prevent="()=> {return false}">
        <v-card-title class="pa-0">
          <v-toolbar class="primary"
                     dark
                     dense
                     flat>
            <v-toolbar-title>
              {{ $t('circleList.redeem.title')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon
                   @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          <v-layout row
                    wrap>
            <v-flex xs12
                    class="px-2">
              <v-text-field :label="$t('circleList.redeem.code')"
                            v-model="form.code"
                            name="code"
                            :rules='codeRules'
                            type="text"
                            required>
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat
                 color="primary"
                 class="capitalize"
                 @click="visible = false">
            {{$t('global.button.cancel')}}
          </v-btn>
          <v-btn :disabled='!valid'
                 :loading="isLoading"
                 type="submit"
                 color="accent"
                 class="capitalize white--text mr-4"
                 @click="submit"
                 round
                 outline>
            {{$t('circleList.redeem.button')}}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import circleService from '@/services/circleService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'CreateCircle',
  components: {
    [WspModal.name]: WspModal
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  computed: {
    codeRules() {
      return [v => !!v || this.$i18n.t('global.validation.required.text')];
    }
  },
  data() {
    return {
      visible: true,
      isLoading: false,
      valid: false,
      form: {
        code: ''
      }
    };
  },
  methods: {
    async submit() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      this.isLoading = true;

      let form = {
        code: this.form.code.replace(/\s/g, '')
      };

      let results = await circleService.redem(form);

      if (results.error) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: this.$i18n.t('error.cicle.not.found'),
          type: 'error',
          doNotTranslate: true
        });
        this.isLoading = false;
        this.valid = true;
        return;
      }

      this.visible = false;
      this.$emit('on-success', {});

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('circleList.toast.added'),
        type: 'info',
        doNotTranslate: true
      });
    }
  }
};
</script>
